import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { translate } from 'react-switch-lang';
import sad from '../../../images/other-images/sad.png';
import { BACK_TO_HOME_PAGE } from '../../constant';

const Error500 = ({ t, history }) => (
  <>
    <div className="page-wrapper">
      {/* <!-- error-500 start--> */}
      <div className="error-wrapper">
        <div className="container">
          <img className="img-100" src={sad} alt="" />
          <div className="error-heading">
            <h2 className="headline font-primary">500</h2>
          </div>
          <div className="col-md-8 offset-md-2">
            <p className="sub-content">{t('global.Error')}</p>
          </div>
          <div>
            <button type="button" className="btn btn-primary-gradien" onClick={() => history.goBack()}>
              {t('global.BACK_TO_HOME_PAGE')}
            </button>
          </div>
        </div>
      </div>
      {/* <!-- error-500 end--> */}
    </div>
  </>
);

export default translate(withRouter(Error500));
